module.exports = __webpack_public_path__ + "assets/img/centerBg.19a3c823.png";